import { render } from "./AppVideo.vue?vue&type=template&id=f15fd7e8&scoped=true"
import script from "./AppVideo.vue?vue&type=script&lang=js"
export * from "./AppVideo.vue?vue&type=script&lang=js"

import "@/Common/Styles/appVideo.scss?vue&type=style&index=0&id=f15fd7e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15fd7e8"]])

export default __exports__